export default __webpack_public_path__ + "static/media/17.ace91f1f.jpeg";